export interface AccessModel {
    role: AccessRoleType;
    roleString: string;
}
export enum AccessRoleType {
    Owner = 1,
    User = 2
}